// extracted by mini-css-extract-plugin
export default {"pageWrap":"ce-z","fullWidth":"de-z","heading":"ee-z","fullBleed":"fe-z","hidden":"ge-z"};